<script>
import { mapState } from "vuex";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";

export default {
	name: "compUmatKematian",
	props: ["triggerValidation"],
	data() {
		return {
			myOptions: {
				kriteria: umatOpt.kriteria,
				paroki: umatData.paroki,
				keuskupan: umatData.keuskupan,
			},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatKematianItem: (state) => state.umatKematian.item,
		}),
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		triggerValidation: function (_newVal, _oldVal) {
			this.trigger();
		},
	},
	methods: {
		validateState(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return !this.veeErrors.has(ref);
			}
			return null;
		},
		validateStateCustom(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				if (this.veeErrors.has(ref)) {
					return { "is-invalid": true };
				} else {
					return { "is-valid": true };
				}
			}
			return null;
		},
		trigger() {
			this.$emit("validate", this.$validator.validateAll());
			this.$validator.validateAll();
		},
	},
};
</script>

<template>
	<div class="form theme-form">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label>Tanggal Meninggal</label>
					<b-form-input
						name="tgl_meninggal"
						:state="validateState('tgl_meninggal')"
						data-vv-as="Tanggal Meninggal"
						v-validate="{ required: true }"
						v-model="umatKematianItem.tgl_meninggal"
						size="sm"
						type="date"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tgl_meninggal")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Tempat Meninggal <span class="text-danger">*</span></label>
					<b-form-input
						name="tempat_meninggal"
						v-model="umatKematianItem.tempat_meninggal"
						v-validate="{ required: true }"
						:state="validateState('tempat_meninggal')"
						data-vv-as="Tempat Meninggal"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tempat_meninggal")
					}}</b-form-invalid-feedback>
				</div>
			</div>
		</div>
	</div>
</template>

